export default "__VITE_ASSET__e7b0f003__"